import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { MainListItems, SecondaryListItems } from '../../user_dashboard/listItems';
import logo5 from "../../logo5.png"
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import * as AuthActions from "../../../store/actions/auth";
import auth from '../../../Landingpagecomponents/Header/auth';
import { withRouter, useHistory } from "react-router-dom";
import Yourdiagnosis from '../../user_dashboard/data/Yourdiagnosis';
import Prognosis from '../../user_dashboard/data/Prognosis';
import Treatmentadvices from "../../user_dashboard/data/treatmentadvice/Treatmentadvice";
import { withStyles } from "@material-ui/core/styles";
import { useFeature } from '../../../featureGating/featureGating';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const GetJournalButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 15,
    padding: "15px 10px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#002D55",
    borderColor: "#002D55",
    color: "#FFFFFF",
    "&:hover": {
        boxShadow: "none",
        backgroundColor: "#0062cc",
        borderColor: "#0062cc"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);
//logout
  //
  //

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));

export default function ProgramBuilder() {
  const [isLoggedIn, setIsLoggedIn] = useState(useSelector(state => state.auth.isLoggedIn))
  const [isLoading, setIsLoading] = useState(false)
  const canAdaptiveExercise = useFeature('adaptive_exercise');

  const [token, _] = useState(useSelector(state => state.auth.token))

  const [diagnosis, setDiagnosis] = useState({
    title: "",
    identifier: "",
    explainer: ""
  })

  const [prognosis, setPrognosis] = useState({
    Expected_outcome: "",
    Typical_character_Symptoms: "",
    Expected_average_duration: "",
    Expected_development: "",
    If_your_symptoms_worsens: ""
  })

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoggedIn) {
      window.location.replace("/");
    }
  }, [isLoggedIn, setIsLoggedIn]);

  useEffect(() => {
    if (isLoggedIn && !canAdaptiveExercise) {
      window.location.replace("/");
    }
  }, [isLoggedIn, canAdaptiveExercise]);

  const handleClickLogout = async () => { 
    console.log('[LOGOUT_HANDLER] handleClickLogout called');
    try {
      console.log('[LOGOUT_HANDLER] Dispatching logout action...');
      await dispatch(AuthActions.logout());
      console.log('[LOGOUT_HANDLER] Logout action completed, redirecting...');
    } catch (e) {
      console.error('[LOGOUT_HANDLER] Error during logout:', e);
      dispatch({type: AuthActions.LOGOUT});
    }
    console.log('[LOGOUT_HANDLER] Redirecting to home...');
    window.location.replace("/");
  };
//virker ovenstående som forventet?



  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const downloadFileTemp = async () => {
    console.log("Downloading")
    console.log(diagnosis)

    setIsLoading(true)
    const response = await fetch("https://api.virtus-one.com/journal/detailed_pdf/"+diagnosis.identifier, { 
      headers: {
        "Authorization": `Token ${token}`
      },
      method: "GET",
    });

    if (response.ok) {
      console.log("SUCCESS")

    } else {
      alert("ERROR")
    }
    setIsLoading(false)
  }

  const fetchDiagnosisData = async () => {
    const response = await fetch("https://api.virtus-one.com/treatment/diagnosis/", { 
      headers: {
        "Authorization": `Token ${token}`
      },
      method: "GET",
    });

    if (response.ok) {
      const data = await response.json();
      setDiagnosis({...data[0].diagnosis})
      setPrognosis({...data[0].prognosis})

    } else {
      alert("ERROR")
    }
    setIsLoading(false)
  }
  
  useEffect(() => {
    setIsLoading(true)
    fetchDiagnosisData()
  }, [])

  
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  if (isLoggedIn) {
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar style={{ color: "#002D55", backgroundColor: "#FFFFFF" }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
          <Toolbar className={classes.toolbar}>
            <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
              <img src={logo5} className={classes.responsive} style={{ margin: 0, maxWidth: 350, minWidth: 200 }} />
            </Typography>
            <IconButton style={{ color: "#f79400", backgroundColor: "#FFFFFF" }}> 
              <Badge badgeContent={6} style={{ color: "#f79400", backgroundColor: "#FFFFFF" }}>
                <NotificationsIcon style={{ color: "#002D55", backgroundColor: "#FFFFFF" }} />
              </Badge>
            </IconButton>
            <Button
              aria-controls="customized-menu"
              aria-haspopup="true"
              variant="contained"
              onClick={handleClickLogout}
              style={{backgroundColor: "#002D55", color: "#FFFFFF", marginRight: 10, marginLeft: 30}}
            >Logout

            </Button>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          <Grid style={{backgroundColor: "#002D55", height: 108}}/>
          <Divider />
          <List style={{marginLeft: 10}}><MainListItems open={open} /></List>
          <Divider />
          <List style={{marginLeft: 10}}><SecondaryListItems open={open} /></List>
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="100%" className={classes.container}>
            <Grid container spacing={3}>
              {/* Recent Deposits */}
              <Grid item xs={12} md={12} lg={4}>
                <Yourdiagnosis 
                  title={diagnosis.title}
                  explainer={diagnosis.explainer}
                />
                <GetJournalButton onClick={downloadFileTemp}/> {/* lav frontend page til at vise dette, email request hvis de vil have PDF */}
              </Grid>
              <Grid item xs={12} md={12} lg={4}>
                <Prognosis 
                  Expected_outcome={prognosis.Expected_outcome}
                  Typical_character_Symptoms={prognosis.Typical_character_Symptoms}
                  Expected_average_duration={prognosis.Expected_average_duration}
                  Expected_development={prognosis.Expected_development}
                  If_your_symptoms_worsens={prognosis.If_your_symptoms_worsens}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={4}>
                <Treatmentadvices /> 
              </Grid>
            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  } else {
    return <div>Unauthorized</div>;
  }
}
